import * as types from '../actionTypes/lookupCode'

export function getEmployeesRestrictions(employeeRestrictions) {
  return {
    type: types.GET_EMPLOYEE_RESTRICTIONS,
    employeeRestrictions
  }
}

export function getLobbyistStatuses(lobbyistStatuses) {
  return {
    type: types.GET_LOBBYIST_STATUSES,
    lobbyistStatuses
  }
}

export function getAnnualReturnTypes(annualReturnTypes) {
  return {
    type: types.GET_ANNUAL_RETURN_TYPES,
    annualReturnTypes
  }
}


// WEBPACK FOOTER //
// ./src/actions/lookupCode.js